/**
 * Metrics Service (Client-side)
 * ==============================
 * WO-GRAFANA-01: Custom threadlock_* metric instrumentation.
 *
 * Writes metric events to the Firestore `metrics` collection.
 * A scheduled Cloud Function (metricsFlush) reads this collection and
 * forwards the counters to GCP Cloud Monitoring every 60 seconds.
 *
 * Security: write-only from authenticated clients (enforced by firestore.rules).
 * This function never throws — metrics must not break the app.
 */

import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

export async function emitMetric(
  name: string,
  value: number = 1,
  labels: Record<string, string> = {}
): Promise<void> {
  if (import.meta.env.MODE !== 'production') return;

  try {
    await addDoc(collection(db, 'metrics'), {
      name,
      value,
      labels,
      flushed: false,
      timestamp: serverTimestamp(),
    });
  } catch (e) {
    // Never throw — metrics must not break the app
    console.debug('[metrics] emit failed silently', e);
  }
}
